var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSl2X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.75C8.85 0.75 10.125 1.05 11.25 1.575C12.375 2.1 13.275 2.85 13.95 3.75C14.625 4.65 15 5.775 15 6.9C15 8.025 14.7 9 14.025 9.975C13.35 10.95 12.45 11.625 11.325 12.15C10.2 12.675 8.925 12.975 7.575 12.975C6.675 12.975 5.775 12.825 4.875 12.6C3.6 13.5 2.25 13.95 0.825 13.95C0.675 13.95 0.525 13.875 0.45 13.8C0.375 13.725 0.225 13.65 0.15 13.5C0.075 13.35 0 13.2 0 13.125C0 13.05 0.075 12.9 0.15 12.825C0.225 12.75 0.375 12.525 0.675 12.15C1.05 11.625 1.35 11.1 1.5 10.65C0.525 9.45 0 8.25 0 6.9C0 5.775 0.3 4.8 0.975 3.825C1.65 2.85 2.625 2.175 3.75 1.575C4.875 0.975 6.15 0.75 7.5 0.75ZM7.5 11.55C8.625 11.55 9.6 11.325 10.575 10.95C11.55 10.575 12.225 9.975 12.825 9.225C13.425 8.475 13.65 7.725 13.65 6.9C13.65 6.075 13.35 5.25 12.75 4.5C12.15 3.75 11.475 3.225 10.5 2.775C9.525 2.325 8.625 2.175 7.5 2.175C6.375 2.175 5.4 2.4 4.425 2.85C3.45 3.3 2.775 3.825 2.25 4.5C1.725 5.175 1.425 6 1.425 6.825C1.425 7.8 1.8 8.7 2.625 9.525L3.225 10.2L2.85 11.1C2.7 11.475 2.55 11.85 2.25 12.3C2.85 12.075 3.375 11.775 3.9 11.4L4.5 11.025L5.25 11.25C5.925 11.475 6.75 11.55 7.5 11.55Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSl2X);
export default __webpack_public_path__ + "static/media/sl-2x.1311a6b4fdb2e03f82e3a6fefd1b84c7.svg";
export { ForwardRef as ReactComponent };